export const DRAWER_SIZE = {
  compact: 'min(430px, calc(100vw - 32px))',
  detail: 'min(1040px, calc(100vw - 32px))',
  form: 'min(720px, calc(100vw - 32px))',
} as const;

export const TABLE_SCROLL_MAX_CONTENT = { x: 'max-content' } as const;
